import classNames from "classnames";
import { html } from "lit-html";

export interface Props {
	firstOptionText: string;
	isOn: boolean;
	secondOptionText: string;
	onChange: (isOn: boolean) => void;
}

export const useRadioToggle = (props: Props) => {
	const radioTemplate = (isChecked: boolean) => html`
		<div
			class=${classNames("relative mr-2 h-6 w-6 rounded-full border-2 border-solid border-n-blue", {
				"after:absolute after:inset-0 after:scale-[0.66] after:transform after:rounded-full after:bg-n-blue after:content-['']":
					isChecked,
			})}
		></div>
	`;

	const handleSelectFirst = () => props.onChange(true);
	const handleSelectSecond = () => props.onChange(false);

	const htmlTemplate = () => html`
		<div class="flex select-none items-center font-body text-sm">
			<div class="mr-4 flex cursor-pointer items-center" @click=${handleSelectFirst}>
				${radioTemplate(!props.isOn)} ${props.firstOptionText}
			</div>
			<div class="flex cursor-pointer items-center" @click=${handleSelectSecond}>
				${radioTemplate(props.isOn)} ${props.secondOptionText}
			</div>
		</div>
	`;

	return { htmlTemplate };
};
